import { type MediaDataRoomJobResultTransform } from "features/mediaDataRoom/hooks";
import { RuleBasedAudienceCondition } from "features/mediaDataRoom/models";
import { type RulesBasedAudienceDataAttributes } from "../models";
import type * as raw from "./models";

const mapFilterOperatorToAudienceCondition: Record<
  raw.FilterOperator,
  RuleBasedAudienceCondition
> = {
  CONTAINS_ALL_OF: RuleBasedAudienceCondition.CONTAINS_ALL_OF,
  CONTAINS_ANY_OF: RuleBasedAudienceCondition.CONTAINS_ANY_OF,
  CONTAINS_NONE_OF: RuleBasedAudienceCondition.CONTAINS_NONE_OF,
  EMPTY: RuleBasedAudienceCondition.EMPTY,
  NOT_EMPTY: RuleBasedAudienceCondition.NOT_EMPTY,
};

export const transformDataAttributes: MediaDataRoomJobResultTransform<
  RulesBasedAudienceDataAttributes
> = async (zip) => {
  const attributesFile = zip.file("attributes.json");
  if (attributesFile === null) {
    throw new Error("attributes.json not found in zip");
  }
  const { attributes } = JSON.parse(
    await attributesFile.async("string")
  ) as raw.RulesBasedAudienceDataAttributesFileStructure;
  return Object.entries(attributes).reduce(
    (acc, [key, { filters, values, value_type }]) => {
      return {
        ...acc,
        [key]: {
          filters: filters.map(
            (filter) => mapFilterOperatorToAudienceCondition[filter]
          ),
          valueType: value_type,
          values,
        },
      };
    },
    {}
  );
};
